import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AlertController, NavController } from '@ionic/angular';
import { foodlist } from '../foodlist';

@Component({
  selector: 'app-details',
  templateUrl: './details.page.html',
  styleUrls: ['./details.page.scss'],
})
export class DetailsPage implements OnInit {
  foodType: string;
  foodList = [];
  selectedFood;
  isLoading = false;
  imageUrl: string;
  answerText: string;
  answerClass: string;
  filter = 'dogs';
  constructor(
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private aletCtrl: AlertController
  ) { }
  ngOnInit() {
    this.isLoading = true;
    this.filter = localStorage.getItem('animalFilter') || 'dogs';
    this.route.params.subscribe((paramMap: Params) => {
      if (!paramMap.name) {
        this.navCtrl.navigateBack('/edible');
        return;
      }
      this.foodType = paramMap.name;
      this.foodList = foodlist;
      this.selectedFood = this.foodList.find(
        (f) =>
          f.name.trim().toLowerCase() === this.foodType.trim().toLowerCase()
      );
      if (!this.selectedFood) {
        this.aletCtrl
          .create({
            header: 'An Error Occured',
            message: 'This food does not exist. Select one from the list.',
            buttons: [
              {
                text: 'Dismiss',
                handler: () => this.navCtrl.navigateBack('/edible'),
              },
            ],
          })
          .then((alerEl) => alerEl.present());
      } else {
        this.loadDetails();
      }
    });
  }

  loadDetails() {
    localStorage.setItem('animalFilter', this.filter);
    if (this.filter === 'dogs') {
      this.loadDogDetails()
    } else {
      this.loadCatDetails()
    }
    this.isLoading = false;
  }

  loadDogDetails() {
    switch (this.selectedFood.canDogsEat.trim().toLowerCase()) {
      case 'yes':
        this.imageUrl = '../../assets/images/foodlist/yes-dog.jpg';
        this.answerText =
          'Yes, It is perfectly safe for your dog to eat it.';
        this.answerClass = 'success';
        break;
      case 'no':
        this.imageUrl = '../../assets/images/foodlist/no-dog.jpg';
        this.answerText = 'NO AMOUNT IS SAFE.';
        this.answerClass = 'danger';
        break;
      default:
        this.imageUrl = '../../assets/images/foodlist/moderate-dog.jpg';
        this.answerText =
          // eslint-disable-next-line max-len
          'It can be used as an occasional treat. However, feeding your dog frequently or in large amounts could cause health problems.';
        this.answerClass = 'primary';
    }
  }

  loadCatDetails() {
    switch (this.selectedFood.canCatsEat.trim().toLowerCase()) {
      case 'yes':
        this.imageUrl = '../../assets/images/foodlist/yes-cat.jpg';
        this.answerText =
          'Yes, It is perfectly safe for your cat to eat it.';
        this.answerClass = 'success';
        break;
      case 'no':
        this.imageUrl = '../../assets/images/foodlist/no-cat.jpg';
        this.answerText = 'NO AMOUNT IS SAFE.';
        this.answerClass = 'danger';
        break;
      default:
        this.imageUrl = '../../assets/images/foodlist/moderate-cat.jpg';
        this.answerText =
          // eslint-disable-next-line max-len
          'It can be used as an occasional treat. However, feeding your cat frequently or in large amounts could cause health problems.';
        this.answerClass = 'primary';
    }
  }
}
